import React from 'react';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  const {
    FaMoneyCheckDollar,
    FaFacebook,
    FaInstagram,
    FaThreads
  } = Fa6Icons;

  const socialLinks = [
    {
      icon: FaThreads,
      url: 'https://www.threads.com/@homy.hk',
      label: 'Homy Tech 的 Threads'
    },
    {
      icon: FaInstagram,
      url: 'https://www.instagram.com/homy.hk',
      label: 'Homy Tech 的 Instagram'
    },
    {
      icon: FaFacebook,
      url: 'https://www.facebook.com/profile.php?id=61578745554661',
      label: 'Homy Tech 的 Facebook'
    }
  ];

  return (
    <footer className="bg-white/50 dark:bg-neutral-800/50 backdrop-blur-md py-10 border-t border-gray-200 dark:border-neutral-700 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center">
          <div className="flex items-center mb-6">
            <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-primary-400 to-secondary-500 text-white rounded-lg shadow-sm mr-2.5">
              <SafeIcon icon={FaMoneyCheckDollar} className="text-sm" />
            </div>
            <span className="font-bold text-lg text-gray-800 dark:text-gray-200 tracking-tight">
              Cheque Fill
            </span>
          </div>

          <div className="flex items-center space-x-5 mb-8">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-neutral-700/50 text-gray-500 dark:text-gray-400 hover:bg-primary-500 hover:text-white dark:hover:bg-primary-600 transition-all duration-300"
                aria-label={social.label}
                title={social.label}
              >
                <SafeIcon icon={social.icon} className="text-lg" />
              </a>
            ))}
          </div>

          <div className="text-center space-y-2">
            <p className="text-xs text-gray-500 dark:text-gray-400">
              © {new Date().getFullYear()} Cheque Fill. All rights reserved.
            </p>
            <div className="text-sm font-medium text-gray-600 dark:text-gray-300">
              Developed by{' '}
              <a
                href="https://homy.hk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 dark:text-primary-400 hover:underline transition-all"
              >
                Homy Tech
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;